import React from "react";
import BaseInput from "../../../../components/BaseInput";
import BaseButton from "../../../../components/BaseButton";
import useController from "./controller";
import BaseTextButton from "../../../../components/BaseTextButton";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function RecoveryForm() {
  const {
    isEmailSending,
    onSubmitEmailHandle,
    errorMessage,
    isValidEmail,
    mailForm,
    onChange,
  } = useController();
  const { t } = useTranslation();
  return (
    <div className="recovery-form">
      <p className={`recovery-form__tip recovery-form__tall`}>
        {t("recovery_page.recovery_tip")}
      </p>
      <div className="recovery-form__code">
        <form onSubmit={onSubmitEmailHandle}>
          <BaseInput
            id="email"
            name="email"
            value={mailForm.email}
            onChange={onChange}
            type="email"
            label={t("email_label")}
            errorMessage={
              !isValidEmail ? t("register_page.email_validate") : errorMessage
            }
          />
          <BaseButton
            loading={isEmailSending}
            disabled={!isValidEmail || !mailForm.email.length}
            type="submit"
            className="recovery-form__btn-next"
          >
            {t("next")}
          </BaseButton>
        </form>
      </div>
    </div>
  );
}
